import { generatePath } from 'react-router-dom';

import { NotificationReader } from 'types';
import { addParamsToUrl } from 'utils/query';

import { URL } from '../constants';
import { apiInstance } from '../instance';

import { NotificationRequest, NotificationResponse } from './types';

export const getNotifications = (params: NotificationRequest) =>
  apiInstance.get<NotificationResponse>(
    addParamsToUrl(URL.GET_NOTIFICATIONS, params)
  );

export const markAsRead = (id: number) =>
  apiInstance.post<NotificationReader>(
    generatePath(URL.MARK_AS_READ_NOTIFICATION, { id: String(id) })
  );

export const markAllAsRead = () =>
  apiInstance.post<number[]>(URL.MARK_ALL_AS_READ_NOTIFICATIONS);
